// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserServiceRequest } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_ACC_USER_SVC, SUC_ACC_USER_SVC } from '../../../../utils/strings';

export const useAcceptUserServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    UserServiceRequest.UserServiceRequest_Accept,
    SUC_ACC_USER_SVC,
    ERR_ACC_USER_SVC,
  );
  return submit;
};
